import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null },
  { prop: 'strCarCode', label: '车签号', width: null },
  { prop: 'strResolveTime', label: '到车时间', width: null },
  { prop: 'strState', label: '状态', width: null },
  { prop: 'strTip', label: '提示/警告信息', width: null },
];
export default { tableHeader }
